import style from './Title.styl';

export function Title({children}) {
  return (
    <h2 className={style.title}>
      {children}
    </h2>
  );
}
